module.exports = __webpack_public_path__ + "img/clockin_icon_endrecording.88a07b9e.png";